import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { IDownloadResultsPackageAPIResponse } from '@models';
import {
  PackageSummaryLocalDataList,
  parseSummaryInfoValues,
} from '../../helpers/results-package-helper';

interface PackageSummaryValuesProps {
  summaryList: PackageSummaryLocalDataList[];
  data: IDownloadResultsPackageAPIResponse;
  timezone: string;
  uiSummaryListLength: number;
}

const PackageSummaryValues: React.FC<PackageSummaryValuesProps> = ({
  summaryList,
  data,
  timezone,
  uiSummaryListLength,
}) => {
  const { t } = useTranslation();
  return (
    <Row>
      {summaryList.map((item) => {
        const value = parseSummaryInfoValues(
          item,
          data,
          uiSummaryListLength,
          timezone,
          t
        );
        return (
          <Col key={item.key} xs={item.colWidth as any} className='pr-0'>
            <p className='font-size-12 font-weight-semi-bold m-0'>{value}</p>
          </Col>
        );
      })}
    </Row>
  );
};

export default PackageSummaryValues;
